import * as React from 'react';
import { useEffect, useRef, useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch, useSelector } from 'react-redux';
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  Container,
  Stack,
  Paper,
  Box,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Checkbox,
  Switch,
  Badge,
  Tooltip,
  Card,
  CardContent,
} from '@mui/material';
import { findCode, fullCopy, printVariable, download, hashids } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import { Grid } from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import { styled } from "@mui/material/styles";
import useAlert from "@hooks/useAlert";
import { useParams, useSearchParams } from 'react-router-dom';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';

import { setSchola } from '@redux/actions/scholaAction';
import ConfirmDialog from "@components/ConfirmDialog";
import { useTheme } from '@mui/material/styles';
import { QuestionMarkTwoTone } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import PublicSurveyPartContent from './public-survey.part.content';
import { useNavigate, useLocation } from 'react-router-dom'

const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;

const PublicSurveyPage = () => {
  const { encSurveyId } = useParams()
  const [searchParams] = useSearchParams()
  const surveyId = hashids.decode(encSurveyId)[0]
  const userToken = searchParams.get("userToken")
  const userId = hashids.decode(userToken)[0]
  console.log('userToke=>', userToken)
  console.log('userId=>', userId)
  const { alert, renderAlert } = useAlert()
  const [notice, set_notice] = useState({})
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const [record, set_record] = useState()
  const [allRepls, set_allRepls] = useState([])
  // key: ${surveyId}_${userId}_${lectureId}_${studentId}, value: Int
  const [replCountMap, set_replCountMap] = useState({})
  const [dirtyQuests, set_dirtyQuests] = useState({})
  const [saved, set_saved] = useState(null)
  const replsRef = useRef([])
  const dispatch = useDispatch()
  const theme = useTheme()
  const account = useSelector(state => state.accountReducer);
  const navigate = useNavigate()
  const location = useLocation()

  const fetchSurvey = async () => {
    console.log('fetchSurvey.....')
    // if(!orgId) {
    //   alert('데이터를 가져올 수 없습니다.')
    //   return
    // }
    // const url = `/public/survey/${orgId}`
    const url = `/public/survey/${encSurveyId}/${userToken}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    const replCountMap = JSON.parse(repMessage.replCountMap)
    // const replCount = +repMessage.replCount
    // if (replCount > 0 && userId > 0) {
    //   set_saved(true)
    // }
    // else {
    //   set_saved(false)
    // }
    console.log('replCountMap=>', replCountMap)
    return [records, replCountMap]
  }

  const onNavigate = (lecture, student) => {
    const url = '/public2/survey/content'
    const pack = {
      data: {
        record: record,
        lecture: lecture,
        student: student,
        userId: userId,
        replCountMap: replCountMap,
      },
      url: window.location.pathname,
    }
    navigate(url, {
      state: {
        pack: pack
      }
    })
  }

  const onLoad = async () => {

    const [records, replCountMap] = await fetchSurvey()
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const now = moment().format(dateFormat)
    const repls = []

    if (records && records.length > 0) {
      const record = records[0]
      const school = record.school
      dispatch(setSchola(school))
      console.log('record=>', record)

      for (const quest of record.quests) {
        const repl = {
          id: -1,
          userId: userId,
          surveyId: quest.surveyId,
          questId: quest.id,
          ansIds: [],
          txt: '',
          regTime: now,
          uptTime: now,
          //
          sqNum: quest.sqNum,
          questCode: quest.questCode,
          mustYn: quest.mustYn,
        }
        repls.push(repl)
      }

      set_allRepls(repls)
      set_record(record)
      set_replCountMap(replCountMap)

    }
  }

  const validate = () => {
    console.log(`allRepls`, allRepls)
    const repls = []
    let alarm = ''
    for (const repl of allRepls) {
      if (repl.mustYn == 'Y') {
        if (repl.questCode === 'Q000' || repl.questCode === 'Q001') {
          if (repl.ansIds.length == 0) {
            dirtyQuests[repl.questId] = '응답 필수입니다.'
            set_dirtyQuests({ ...dirtyQuests })

            alarm = `Q.${repl.sqNum} 응답 필수입니다.`
            alert(alarm)

            const element = document.getElementById(`quest-${repl.questId}`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return
          }
          else {
            for (const ansId of repl.ansIds) {
              const d = { ...repl, ansId: ansId }
              repls.push(d)
            }
          }
        }
        else {
          if (!repl.txt.trim()) {
            alarm = `Q.${repl.sqNum} 응답 필수입니다.`
            alert(alarm)
            dirtyQuests[repl.questId] = '응답 필수입니다.'
            set_dirtyQuests({ ...dirtyQuests })

            const element = document.getElementById(`quest-${repl.questId}`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            return
          }
          else {
            const d = { ...repl, ansId: -1 }
            repls.push(d)
          }
        }
      }
      else {
        if (repl.questCode === 'Q000' || repl.questCode === 'Q001') {
          if (repl.ansIds.length > 0) {
            for (const ansId of repl.ansIds) {
              const d = { ...repl, ansId: ansId }
              repls.push(d)
            }
          }
        }
        else {
          if (repl.txt.trim()) {
            const d = { ...repl, ansId: -1 }
            repls.push(d)
          }
        }
      }
    }
    replsRef.current = repls
    console.log('repls=>', replsRef.current)
    return true
  }

  const onDeleteRepl = async () => {
    const url = `/public/survey/repl/${encSurveyId}/user/${userToken}`
    const resp = await WebService.delete(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    alert('삭제되었습니다.', () => {
      window.location.reload()
    })

    // openSnackbar('삭제되었습니다.')
  }

  const onSubmit = async () => {
    if (replsRef.current.length == 0) {
      return
    }
    const surveyId = replsRef.current[0].surveyId

    const url = `/public/survey/repl/${surveyId}`
    const data = {
      surveyRepls: JSON.stringify(replsRef.current)
    }

    console.log('data=>', data)
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode != 'ack') {
      alert(resp.repMessage)
      return
    }

    set_saved(true)
    alert('설문제출이 완료되었습니다. 설문조사에 응해 주셔서 감사합니다.')

  }

  useEffect(() => {
    onLoad()
  }, [])

  useEffect(() => {
    if (record?.id && record?.modeCode === 'M000') {
      onNavigate()
    }
  }, [record])

  if(record?.id && record.statCode !== 'R001') {
    return(
      <Container maxWidth='sm'>
        <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2 }} variant='h5'>
            {record?.title}
          </Typography>
          <Typography  textAlign={'center'}>
            해당 설문조사는 게시 중이 아닙니다.
          </Typography>
        </Grid>
        </Grid>
      </Container>
    )

  }

  return (
    <Container maxWidth='sm'>
      {renderIndicator()}
      {renderAlert()}

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography sx={{ fontWeight: 'bold', textAlign: 'center', mb: 2 }} variant='h5'>
            {record?.title}
          </Typography>
          <Typography variant='body2' sx={{ whiteSpace: 'pre-line', color: '#666', mb: 3 }}>
            {record?.content}
          </Typography>
        </Grid>
        {
          record?.imgUrl ? (
            <Grid item xs={12}>
              <img style={{width:'100%'}} src={record.imgUrl}/>
            </Grid>
          ) : null
        }

        <Grid item xs={12}>
          {(record?.modeCode === 'M001' || record?.modeCode === 'M002' ) && record?.smstId > 0 ? (
            record?.studentList?.length > 0 ? (
              record.studentList.map((student) => (
                <Box key={`std-${student.id}`} sx={{ mb: 3, p: 2, borderRadius: 2, bgcolor: '#f9f9f9', border: '1px solid #eee' }}>
                  {/* <div style={{display:'flex', alignItems:'center', justifyContent:'center', marginBottom:10}}> */}
                  <Stack direction="row" spacing={2} sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'center' }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                      {student.name}
                    </Typography>
                    <Typography variant='body2'>
                      {student.grade}학년 {student.className}반 {student.classNum}번
                    </Typography>
                  </Stack>
                  {/* </div> */}


                  {student.lectureList.length > 0 ? (
                    <Stack spacing={1}>
                      {student.lectureList.map((lecture) => (
                        <Card
                          key={`lec-${lecture.id}`}
                          variant="outlined"
                          sx={{ cursor: 'pointer', '&:hover': { bgcolor: '#f0f7ff', borderColor: theme.palette.primary.light } }}
                          onClick={() => onNavigate(lecture, student)}
                        >
                          <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                            <Typography sx={{ fontWeight: 'bold' }}>
                              {lecture.title}
                            </Typography>
                            {
                              (() => {
                                const key = `${record.id}_${userId}_${lecture.id}_${student.id}`
                                const replCount = replCountMap[key] ?? 0
                                if (replCount > 0) {
                                  return <Typography variant='body2'>제출 완료</Typography>
                                }
                                else {
                                  return <Typography variant='body2'>미 제출</Typography>
                                }
                              })()
                            }
                            <Typography variant='caption' color='text.secondary'>설문 참여하기 →</Typography>
                          </CardContent>
                        </Card>
                      ))}
                    </Stack>
                  ) : (
                    <Typography variant='body2' color='text.secondary' fontStyle='italic'>참여 가능한 강좌가 없습니다.</Typography>
                  )}
                </Box>
              ))
            ) : (
              <>
                <Typography textAlign='center' sx={{ mt: 4 }}>학생정보를 불러올 수 없습니다.</Typography>
                <Typography textAlign='center' sx={{ mt: 1 }}>강좌 설문조사는 보호자님의 자녀가 수강중인 강좌가 있어야 제출 가능합니다.</Typography>
              </>

            )
          ) : null}
        </Grid>
      </Grid>
    </Container>

  )
}

export default PublicSurveyPage
